import React, { useState } from "react";
import { downloads } from "../../../store/actions/downloads";
import { useSelector, useDispatch } from "react-redux";

const JSONDownload = () => {
  const [radioValue, setRadioValue] = useState("CREATE_REQUEST");
  const [proposalNumber, setProposal] = useState({
    propsal: "",
    error: false,
  });
  const downloadsJSONData = useSelector(
    (state) =>
      state.downloads &&
      state.downloads.downloadsJSON &&
      state.downloads.downloadsJSON.jsonRequest
  );
  const dispatch = useDispatch();

  const inputHandler = (e) => {
    setProposal({ propsal: e.target.value, error: false });
  };

  const radios = [
    { name: "Create request", value: "CREATE_REQUEST" },
    { name: "Create response", value: "CREATE_RESPONSE" },
    { name: "Submit request", value: "SUBMIT_REQUEST" },
    { name: "Submit response", value: "SUBMIT_RESPONSE" },
  ];

  const searchItem = (event) => {
    event.preventDefault();
    if (proposalNumber.propsal) {
      const path = `jsonRequest/${radioValue}/${proposalNumber.propsal}`;
      dispatch(downloads(path));
    } else {
      setProposal({ ...proposalNumber, error: true });
    }
  };

  return (
    <>
      <div className="downloads-page__panel">
        <p className="downloads-page__hint">
          Enter proposal number to view JSON request and response payloads
        </p>

        <div className="downloads-page__toggle-row downloads-page__toggle-row--wrap">
          {radios.map((radio) => (
            <button
              key={radio.value}
              type="button"
              className={`downloads-page__toggle ${
                radioValue === radio.value ? "selected" : ""
              }`}
              onClick={() => setRadioValue(radio.value)}
            >
              {radio.name}
            </button>
          ))}
        </div>

        <form className="downloads-page__search-form" onSubmit={searchItem}>
          <div className="downloads-page__field">
            <label className="downloads-page__label" htmlFor="json-proposal">
              Proposal Number
            </label>
            <input
              id="json-proposal"
              onChange={inputHandler}
              value={proposalNumber.propsal}
              className="downloads-page__input"
              type="text"
              placeholder="Enter proposal number"
              name="proposalNumber"
            />
          </div>
          {proposalNumber.error && (
            <div className="downloads-page__error">
              Please enter proposal number
            </div>
          )}
          <div className="downloads-page__actions">
            <button
              type="submit"
              className="downloads-page__btn downloads-page__btn--primary"
            >
              Search
            </button>
          </div>
        </form>
      </div>

      {downloadsJSONData && (
        <div className="proposal-dashboard__table-section downloads-page__table-section">
          <div className="proposal-table downloads-page__json-output">
            <pre>{JSON.stringify(downloadsJSONData, null, 2)}</pre>
          </div>
        </div>
      )}
    </>
  );
};

export default JSONDownload;
